import { Component, Input, OnInit } from '@angular/core';
import { DirectionService } from '@services/direction.service';
import { TranslateHelper } from '@app/_helpers';
import { TranslateService } from '@ngx-translate/core';
import { PostCardComponent } from '../../shared/components/post-card/post-card.component';
import { NgFor } from '@angular/common';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BlockHeaderComponent } from '../components/block-header/block-header.component';

@Component({
    selector: 'app-block-posts',
    templateUrl: './block-posts.component.html',
    styleUrls: ['./block-posts.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [BlockHeaderComponent, CarouselModule, OwlPreventClickDirective, NgFor, PostCardComponent]
})
export class BlockPostsComponent implements OnInit {
    @Input() header = {en :''};
    @Input() layout;
    @Input() posts: any[] = [];
    @Input() items = {
        desktop: 2,
        mobile: 2,
        tablet: 1
    };
    @Input() class = "";

    carouselDefaultOptions = {
        lazyLoad: true,
        margin: 30,
        nav: false,
        dots: false,
        loop: true,
        skip_validateItems: true,
        rtl: this.direction.isRTL(),
        responsive: {
            1300: { items: 4, margin: 12 },
            1050: { items: 2, margin: 8 },
            690: { items: 2, margin: 8 },
            0: { items: 1 }
        }

    };


    /*    get carouselOptions(): any {
           return Object.assign({}, this.carouselDefaultOptions, this.items);
       } */

    constructor(
        private direction: DirectionService,
        public translateHelper: TranslateHelper,
        public translate: TranslateService
    ) { }


    ngOnInit(): void {
        this.carouselDefaultOptions.responsive = {
            1300: { items: +this.items.desktop || 4, margin: 12 },
            1050: { items: +this.items.desktop || 4, margin: 8 },
            690: { items: +this.items.tablet || 2, margin: 8 },
            0: { items: +this.items.mobile || 1 }
        };
    }
}
